import {createRefreshParamInterface} from './types';

function createRefresh(param: createRefreshParamInterface)
  :createRefreshParamInterface {
  return param;
}

export default createRefresh;